export const SEARCH_PAYMENT_ITEM_CONSTANTS = {
  DIALOG: {
    TITLE: 'Add item',
    CLOSE_BUTTON: 'Close',
  },
  SEARCH: {
    HEADER: 'Search by Description, CCSD Code, or Consultant',
    PLACEHOLDER: 'Description or CCSD code',
  },
  RESULTS: {
    ERROR: 'Error loading items',
    NO_ITEMS: 'No items found',
  },
  DETAILS: {
    CONSULTANT: {
      NAME: 'Consultant Name',
      CONSULTATION_FEE: 'Consultation Fee',
      FOLLOWUP_FEE: 'Follow-up Fee',
    },
    PROCEDURE: {
      DESCRIPTION: 'Procedure Description',
      CCSD_CODE: 'CCSD Code',
      CATEGORY: 'Category',
      EYE_INVOLVEMENT: 'Eye Involvement',
      PRICE: 'Procedure Price',
      NOTES: 'Notes',
    },
  },
  BUTTONS: {
    ADD_ITEM: 'Add Item',
  },
  PLACEHOLDERS: {
    NOTES: 'Enter notes (optional)',
  },
} as const;
